// Angular
import { Component, EventEmitter, Input, Output } from '@angular/core';

// Libraries
import { IFieldSpecs } from "../interfaces/field-specs";

export enum ETextAreaClass {
    fullWidth = 'fullWidth',

}

@Component({
    selector: 'simple-textarea-field',
    template: `
        <form-field [formGroup]="fieldConfig.formGroup"
                    [attr.class]="fieldConfig.className"
                    [options]="fieldConfig"
                    [class]="class">
            <textarea class="field text-field"
                    type="text"
                    [class]="class"
                    [formControlName]="fieldConfig.formControlName"
                    [attr.placeholder]="fieldConfig.placeholder"
                    [tabindex]="fieldConfig.tabindex" 
                    (blur)="onBlur.emit($event)"></textarea>
        </form-field>
    `,
    styles: [`
        .fullWidth {
            width: 100%;
            resize: vertical;
            height: 150px;
        }
    `]
})
export class SimpleTextareaFieldComponent {
    @Input()
    public fieldConfig: IFieldSpecs;

    @Input()
    public class: ETextAreaClass = null;

    @Output()
    public readonly onBlur: EventEmitter<string> = new EventEmitter();

}
